<template>
  <div class="d-flex flex-column align-start justify-start">
    <v-skeleton-loader type="text" width="60" class="skeleton-data-title" />
    <div class="d-flex">
      <div class="d-flex align-end me-2">
        <v-skeleton-loader type="text" width="30" class="skeleton-data-total" />
      </div>
      <div class="d-flex flex-column">
        <div class="mb-1">
          <v-skeleton-loader type="chip" class="skeleton-data-chip" />
        </div>
        <v-skeleton-loader
          type="text"
          width="80px"
          class="skeleton-data-title"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.skeleton-data-title {
  .v-skeleton-loader__text {
    height: 9px;
  }
}
.skeleton-data-total {
  .v-skeleton-loader__text {
    height: 24px;
  }
}

.skeleton-data-chip {
  .v-skeleton-loader__chip {
    height: 16px;
    width: 50px;
  }
}
</style>
